/**
 * Quotation PDF Generator
 * Client-side @react-pdf/renderer based generator with Arabic/English support.
 */
import React from 'react';
import QuotationDocument from '../../components/pdf/QuotationDocument';
import { renderPdfDocumentToBlob } from '../../components/pdf/pdfTextUtils';
import { companySettingsService } from '../system/company-settings';
import { saudiCities } from '../../data/saudiCities';

export const downloadQuotationPDF = async (quotation, company, options = {}) => {
  const {
    language = 'ar',
    termsAndConditions = { ar: [], en: [] },
    favoriteRoutes = [],
  } = options;

  // Resolve company settings (logo, address, vat, etc.)
  let companySettings = null;
  if (company?.id) {
    try {
      companySettings = await companySettingsService.getCompanySettings(company.id);
    } catch {
      // proceed without settings
    }
  }

  // Build the routes list (favorite + manual)
  const allRoutes = [
    ...(favoriteRoutes || []),
    ...(quotation.manualRoutes || []),
  ].filter(Boolean);
  const selectedIds = quotation.selectedRoutes || [];
  // Preserve the user-defined order from selectedIds
  let routes = selectedIds
    .map(id => allRoutes.find(r => r.id === id))
    .filter(Boolean);

  // Fallback: if there's a single fromCity/toCity/price (no selected routes)
  if (routes.length === 0 && quotation.fromCity && quotation.toCity) {
    routes = [{
      id: 'single',
      fromCity: quotation.fromCity,
      toCity: quotation.toCity,
      price: Number(quotation.price) || Number(quotation.totalAmount) || 0,
    }];
  }

  const blob = await renderPdfDocumentToBlob(
    <QuotationDocument
      quotation={quotation}
      company={company}
      companySettings={companySettings}
      routes={routes}
      options={{ language, termsAndConditions, cities: saudiCities }}
    />
  );

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Quotation_${quotation.quotationNumber || quotation.id}_${language.toUpperCase()}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
